import * as jose from "node-jose";
import { from, Observable } from "rxjs";

const characters: string = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const digits: string = "0123456789";

export class CryptoUtils {
    constructor() { }

    public static importKey(input: any, format: string) {
        return jose.JWK.asKey(input, format);
    }

    public static generateKey(
        keyType: string,
        keyLength: any,
        properties: any
    ): Observable<any> {
        let keystore = jose.JWK.createKeyStore();
        return from(keystore.generate(keyType, keyLength, properties));
    }

    public static encrypt(input, key) {
        return jose.JWE.createEncrypt({ format: "compact" }, key)
                .update(input)
                .final()
        ;
    }

    public static decryptFromKeyStore(input, keyStore) {
        return jose.JWE.createDecrypt(keyStore).decrypt(input);
    }

    public static toBufferFromBase64(input: string): string {
        return jose.util.base64url.decode(input);
    }

    public static toBase64(input: string) {
        return jose.util.base64url.encode(input, "utf8");
    }

    public static toBase64FromBuffer(input: any) {
        return jose.util.base64url.encode(input);
    }

    public static randomKeyBuffer(size: number) {
        return jose.util.randomBytes(size);
    }

    public static randomKeyString(size: number) {
        return Array(size)
            .join()
            .split(",")
            .map(function () {
                return characters.charAt(
                    Math.floor(Math.random() * characters.length)
                );
            })
            .join("");
    }

    public static randomNumberString(size: number) {
        return Array(size)
            .join()
            .split(",")
            .map(function () {
                return digits.charAt(Math.floor(Math.random() * digits.length));
            })
            .join("");
    }

    public static AesGcmDecrypt(key, cipherText): Observable<any> {
        return from(jose.JWA.decrypt("A256GCMKW", key, cipherText));
    }

    public static AesGcmEncrypt(key, plainText): Observable<any> {
        return from(jose.JWA.encrypt("A256GCMKW", key, plainText));
    }
}
